var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.counts)?_c('div',{staticClass:"steps"},[_c('ul',{staticClass:"steps-list"},_vm._l((_vm.stepsCount),function(index){return _c('li',{key:index,staticClass:"step",class:{ active: _vm.step >= index },attrs:{"data-count":index}})}),0),_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }